import ApplicationAdapter from './application';

export default class ComponentReviewCommentAdapter extends ApplicationAdapter {
  namespace = 'api/v2';
}
